<div class="container">
    <div class="row">
        <div class="col-md-3">
            <div class="card" style="width: 18rem;float: left; margin-right: 1em;">
                <div style="text-align:center;padding: 1em 0.3em;">
                    <img class="card-img-top profileImg" width="50px" [src]="collegeData.image">
                    <div class="userName">
                        <p>{{ collegeData.collage_name }}</p>
                        <p>{{ collegeData.contact_no }}</p>
                        <p>{{ collegeData.contact_email }}</p>
                    </div>
                </div>
                <hr>
                <div class="card-body">
                    <h5>About us</h5>
                    <p style="text-align:justify;">{{ collegeData.description }}</p>
                    <h5>Hint</h5>
                    <p style="text-align:justify;">{{ collegeData.hint }}</p>
                    <h5>District</h5>
                    <p>{{ collegeData.districtName }} </p>
                    <h5>State</h5>
                    <p>{{ collegeData.stateName }}</p>
                </div>
            </div>
        </div>

        <div class="col-md-9">
            <div class="card card-right">
                <div class="card-body" *ngFor="let college of individualCollege">
                    <h6 class="card-title">{{ college.college_name }}</h6>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5>Courses</h5>
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="addCourse()">+ Add
                                Courses</button>
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="viewCourse()">View All</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 formData" *ngFor="let course of courseData">
                            <div class="row">
                                <div class="col-sm-12 collegeData">
                                    <h5 style="padding:0.3em 0.5em;">{{ course.degree }}</h5>
                                    <p style="padding:0.3em 0.5em;">{{ course.course_name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>



                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5>College Fees Images</h5>
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="addfeesImages()">Add
                                Syllabus</button>
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="viewfeesImages()">View
                                All</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3" *ngFor="let images of newDatas" style="margin-bottom: 1em !important;">
                            <div class="img-wraps">
                                <img [src]="images.college_fees_images" class="clgImg">
                                <i class="fa fa-trash-o closes" aria-hidden="true" (click)="deletefeesImage(images)"></i>
                            </div>
                        </div>
                    </div>

                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5>Images</h5>
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="addImages()">+ Add
                                Images</button>
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="viewImages()">View
                                All</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3" *ngFor="let image of newData" style="margin-bottom: 1em !important;">
                            <div class="img-wraps">
                                <img [src]="image.college_images" class="clgImg">
                                <i class="fa fa-trash-o closes" aria-hidden="true" (click)="deleteImage(image)"></i>
                            </div>
                        </div>
                    </div>

                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5>Videos</h5>
                        </div>
                        <div class="col-md-6" style="text-align: right;">
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="addVideos()">+ Add
                                Videos</button>
                            <button type="button" class="btn btn-primary addCourseBtn" (click)="viewVideos()">View All</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 formData" *ngFor="let video of videoData">
                            <div class="row">
                                <div class="col-sm-3">
                                    <img [src]="video.video_image" width="30px" height="30px" class="rounded-circle">
                                </div>
                                <div class="col-sm-7 collegeData">
                                    <h5>{{ video.url }}</h5>
                                </div>
                                <div class="col-sm-1">
                                    <i class="fa fa-trash-o" (click)="deleteVideo(video)" aria-hidden="true" style="color: red;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="backdrop" [ngStyle]="{'display':display}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    Add Courses
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <!-- <div class="modal-header" *ngIf="showEdit">
                            Edit Images
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div> -->
                <div class="dltmodal-content animate modal-body dltBl">
                    <form [formGroup]="courseaddForm">
                        <label>Courses</label>
                        <div class="row">
                            <div class="col-md-4" *ngFor="let scope of scopeData; let i=index">
                                <div class="checkboxDesign">
                                    <input type="checkbox" formControlName="courseVal" [(ngModel)]="scope.check" class="form-check-input" [ngValue]="scope.id" (change)="onCheckChange($event)">
                                    <span>{{ scope.degree }} - {{ scope.courses }}</span>
                                    <!-- <div class="error-messages">
                                            <div *ngFor="let error of error_messages.feesVal">
                                                <div class="error-message" *ngIf="courseaddForm.get('feesVal').hasError(error.type) && (courseaddForm.get('feesVal').dirty || courseaddForm.get('feesVal').touched)">
                                                    {{ error.message }}
                                                </div>
                                            </div>
                                        </div> -->
                                </div>
                            </div>
                            <!-- <div class="col-md-4">
                                <label>Fees</label>
                                <input type="text" class="form-control" formControlName="feesVal" [ngStyle]="{'pointer-events':scope.check ? 'auto' : 'none' }" [(ngModel)]="scope.fees" [ngValue]="scope.fees" [ngModelOptions]="{standalone: true}"> -->
                            <!-- <div class="error-messages">
                                            <div *ngFor="let error of error_messages.feesVal">
                                                <div class="error-message" *ngIf="courseaddForm.get('feesVal').hasError(error.type) && (courseaddForm.get('feesVal').dirty || courseaddForm.get('feesVal').touched)">
                                                    {{ error.message }}
                                                </div>
                                            </div>
                                        </div> -->
                            <!-- </div> -->

                            <!-- <div class="col-md-4">
                                <label>Trust Fees</label>
                                <input type="text" class="form-control" formControlName="trustFeesVal" [ngStyle]="{'pointer-events':scope.check ? 'auto' : 'none' }" [(ngModel)]="scope.trustFees" [ngValue]="scope.trustFees" [ngModelOptions]="{standalone: true}"> -->
                            <!-- <div class="error-messages">
                                            <div *ngFor="let error of error_messages.trustFeesVal">
                                                <div class="error-message" *ngIf="courseaddForm.get('trustFeesVal').hasError(error.type) && (courseaddForm.get('trustFeesVal').dirty || courseaddForm.get('trustFeesVal').touched)">
                                                    {{ error.message }}
                                                </div>
                                            </div>
                                        </div> -->
                            <!-- </div> -->
                        </div>

                        <div class="addBtn">
                            <button class="commonBtn mt-2" (click)="addCourses()">
                                Add Courses</button>
                        </div>
                        <!-- <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2"> Update</button>
                                </div> -->
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- ----------------------------------------------------------------------------------
 -->
    <div class="backdrop" [ngStyle]="{'display':displayfeesImages}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayfeesImages}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" *ngIf="showAdd">
                    Add Syllabus
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                     <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-header" *ngIf="showEdit">
                    Edit Images
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                     <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl">
                    <form [formGroup]="collegeImagesForm">
                        <label class="uploadImage">Upload Image
                         <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                         <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple=""
                             hidden>
                     </label>
                        <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images" [src]="img">
                        <div class="error-messages">
                            <div *ngFor="let error of error_messages.colgImg">
                                <div class="error-message" *ngIf="collegeImagesForm.get('colgImg').hasError(error.type) && (collegeImagesForm.get('colgImg').dirty || collegeImagesForm.get('colgImg').touched)">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>

                        <div class="addBtn" *ngIf="showAdd">
                            <button class="commonBtn mt-2" [disabled]="!collegeImagesForm.valid" (click)="addCollegefeesImages()">
                             Add Syllabus</button>
                        </div>
                        <div class="addBtn" *ngIf="showEdit">
                            <button class="commonBtn mt-2"> Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- ----------------------------------------------------
 -->
    <div class="backdrop" [ngStyle]="{'display':displayImages}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayImages}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" *ngIf="showAdd">
                    Add Images
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-header" *ngIf="showEdit">
                    Edit Images
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl">
                    <form [formGroup]="collegeImagesForm">
                        <label class="uploadImage">Upload Image
                            <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                            <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple=""
                                hidden>
                        </label>
                        <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images" [src]="img">
                        <div class="error-messages">
                            <div *ngFor="let error of error_messages.colgImg">
                                <div class="error-message" *ngIf="collegeImagesForm.get('colgImg').hasError(error.type) && (collegeImagesForm.get('colgImg').dirty || collegeImagesForm.get('colgImg').touched)">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>

                        <div class="addBtn" *ngIf="showAdd">
                            <button class="commonBtn mt-2" [disabled]="!collegeImagesForm.valid" (click)="addCollegeImages()">
                                Add Images</button>
                        </div>
                        <div class="addBtn" *ngIf="showEdit">
                            <button class="commonBtn mt-2"> Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="backdrop" [ngStyle]="{'display':displayVideo}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayVideo}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" *ngIf="showAdd">
                    Add Video
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-header" *ngIf="showEdit">
                    Edit Video
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl">
                    <form [formGroup]="videoForm">

                        <div style="text-align:center;">
                            <img width="80px" height="80px" *ngIf="imageUrl" [src]="imageUrl" class="rounded-circle">
                            <label class="rounded-circle imgLabel">
                                <i class="fa fa-camera" aria-hidden="true"></i><input type="file" formControlName="imageVal"
                                    (change)="handleImageFileInput($event.target.files)" hidden>
                            </label>
                        </div>
                        <div class="error-messages">
                            <div *ngFor="let error of error_messages.imageVal">
                                <div class="error-message" *ngIf="videoForm.get('imageVal').hasError(error.type) && (videoForm.get('imageVal').dirty || videoForm.get('imageVal').touched)">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>

                        <label>Video URL</label>
                        <input class="form-control" [(ngModel)]="videoUrl" formControlName="videoVal">
                        <div class="error-messages">
                            <div *ngFor="let error of error_messages.videoVal">
                                <div class="error-message" *ngIf="videoForm.get('videoVal').hasError(error.type) && (videoForm.get('videoVal').dirty || videoForm.get('videoVal').touched)">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>

                        <div class="addBtn" *ngIf="showAdd">
                            <button class="commonBtn mt-2" [disabled]="!videoForm.valid" (click)="addVideo()">
                                Add Video</button>
                        </div>
                        <div class="addBtn" *ngIf="showEdit">
                            <button class="commonBtn mt-2" (click)="updateVideo()" [disabled]="!videoForm.valid">
                                Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                    <p>Do you want to delete College Images ?</p>
                    <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                    <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                    <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                </div>
            </div>
        </div>
    </div>


    <div class="backdrop" [ngStyle]="{'display':displayfeesDelete}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayfeesDelete}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                    <p>Do you want to delete Syllabus Images ?</p>
                    <button type="submit" class="btn btn-success" (click)="deletefees()" style="width: 20%;">Yes</button>
                    <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                    <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="backdrop" [ngStyle]="{'display':displayVideoDelete}"></div>
    <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayVideoDelete}">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                    <p>Do you want to delete Course Type ?</p>
                    <button type="submit" class="btn btn-success" (click)="videoDelete()" style="width: 20%;">Yes</button>
                    <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                    <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                </div>
            </div>
        </div>
    </div>

</div>